import { Box, Typography } from "@mui/material";
import SalesPerDayMonth from "./VentasDatos/SalesPerDayMonth";
import SalesPerDay15 from "./VentasDatos/SalesPerDay15";
import TotalSalesMonth from "./VentasDatos/TotalSalesMonth";
import AverageTotalSales30Days from "./VentasDatos/AverageTotalSales30Days";
import AverageCountSales30Days from "./VentasDatos/AverageCountSales30Days";

import TopPayments from "./GastosDatos/TopPayments";
import TopShops from "./GastosDatos/TopShops";
import PaymentPerformance from "./GastosDatos/PaymentPerformance";
import TotalExpenses from "./GastosDatos/TotalExpenses";

import WeeklyOperations from "./ActividadDatos/WeeklyOperations";
import OperationPercentages from "./ActividadDatos/OperationPercentages";
import TotalProfit from "./ActividadDatos/TotalProfit";

export default function Datos() {
  return (
    
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        //width: "100%",
        //height: "100%",
      }}
    >
      {/* --------------------------- Ventas --------------------------- */}
      <Typography 
        variant="h4"
        pt={1} 
        mb={1}
        textAlign={"center"}
        borderBottom={"solid 2px black"}
      > 
        Ventas 
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "66vh",
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            width: "65%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              justifyContent: "space-between",
              //width: "16%",
              height: "30%",
              gap: 1,
            }}
          >
            <TotalSalesMonth />
            <AverageTotalSales30Days />
            <AverageCountSales30Days />
          </Box>
          <SalesPerDayMonth />
        </Box>
        <Box
          sx={{
            width: "32%",
            mt: 1,
          }}
        >
          <SalesPerDay15 />
        </Box>
      </Box>

      {/* --------------------------- Actividad --------------------------- */}
      <Typography 
        variant="h4"
        pt={2} 
        mb={1}
        mt={3}
        textAlign={"center"}
        borderBottom={"solid 2px black"}
      > 
        Actividad 
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "86vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            height: "50%",
            alignItems: "center",
            gap: 2,
          }}
        >
          <TopPayments />
          <TopShops />
          <PaymentPerformance />
          <TotalExpenses />


        </Box>
          <Typography 
            variant="h4"
            pt={2} 
            mb={1}
            textAlign={"center"}
            borderBottom={"solid 2px black"}
          > 
            Ingresos / Actividad 
          </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            height: "50%",
            alignItems: "center",
            gap: 4,
          }}
        >
          <WeeklyOperations />
          <OperationPercentages />
          <TotalProfit />
        </Box>

      </Box>

    </Box>
  );
}
